import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { OptionsDictionary } from './SortOptionDefinitions';
import { createNonDisplayOptionDefinition } from './SortOptionsHelper';

export const defaultUserSort = [Order.asc(OrderKeys.displayName)];

export const userSortOptions: OptionsDictionary = {
  'userName': createNonDisplayOptionDefinition('userName', OrderKeys.username),
  'displayName': createNonDisplayOptionDefinition('displayName', OrderKeys.displayName),
  'domainName': createNonDisplayOptionDefinition('domainName', OrderKeys.domainName),
};
